 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import TEXT9781611532203 from '@/components/Text/9781611532203'
 import TEXT97816115322031 from '@/components/Text/97816115322031'
 import TEXT97816115322032 from '@/components/Text/97816115322032'
 import TEXTTOC from '@/components/Text/TOC'
 import TEXT97816115322033 from '@/components/Text/97816115322033'
 import TEXT97816115322034 from '@/components/Text/97816115322034'
 import TEXT97816115322035 from '@/components/Text/97816115322035'
 import TEXT97816115322036 from '@/components/Text/97816115322036'
 import TEXT97816115322037 from '@/components/Text/97816115322037'
 import TEXT97816115322038 from '@/components/Text/97816115322038'
 import TEXT97816115322039 from '@/components/Text/97816115322039'
 import TEXT978161153220310 from '@/components/Text/978161153220310'
 import TEXT978161153220311 from '@/components/Text/978161153220311'
 import TEXT978161153220312 from '@/components/Text/978161153220312'
 import TEXT978161153220313 from '@/components/Text/978161153220313'
 import TEXT978161153220314 from '@/components/Text/978161153220314'
 import TEXT978161153220315 from '@/components/Text/978161153220315'
 import TEXT978161153220316 from '@/components/Text/978161153220316'
 import TEXT978161153220317 from '@/components/Text/978161153220317'
 import TEXT978161153220318 from '@/components/Text/978161153220318'
 import TEXT978161153220319 from '@/components/Text/978161153220319'
 import TEXT978161153220320 from '@/components/Text/978161153220320'
 import TEXT978161153220321 from '@/components/Text/978161153220321'
 import TEXT978161153220322 from '@/components/Text/978161153220322'
 import TEXT978161153220323 from '@/components/Text/978161153220323'
 import TEXT978161153220324 from '@/components/Text/978161153220324'
 import TEXT978161153220325 from '@/components/Text/978161153220325'
 import TEXT978161153220326 from '@/components/Text/978161153220326'
 import TEXT978161153220327 from '@/components/Text/978161153220327'
 import TEXT978161153220328 from '@/components/Text/978161153220328'
 import TEXT978161153220329 from '@/components/Text/978161153220329'
 import TEXT978161153220330 from '@/components/Text/978161153220330'
 import TEXT978161153220331 from '@/components/Text/978161153220331'
 import TEXT978161153220332 from '@/components/Text/978161153220332'
 import TEXT978161153220333 from '@/components/Text/978161153220333'
 import TEXT978161153220334 from '@/components/Text/978161153220334'
 import TEXT978161153220335 from '@/components/Text/978161153220335'
 import TEXT978161153220336 from '@/components/Text/978161153220336'
 import TEXT978161153220337 from '@/components/Text/978161153220337'
 import TEXT978161153220338 from '@/components/Text/978161153220338'
 import TEXT978161153220339 from '@/components/Text/978161153220339'
 import TEXT978161153220340 from '@/components/Text/978161153220340'
 import TEXT978161153220341 from '@/components/Text/978161153220341'
 import TEXT978161153220342 from '@/components/Text/978161153220342'
 import TEXT978161153220343 from '@/components/Text/978161153220343'
 import TEXT978161153220344 from '@/components/Text/978161153220344'
 import TEXT978161153220345 from '@/components/Text/978161153220345'
 import TEXT978161153220346 from '@/components/Text/978161153220346'
 import TEXT978161153220347 from '@/components/Text/978161153220347'
 import TEXT978161153220348 from '@/components/Text/978161153220348'
 import TEXT978161153220349 from '@/components/Text/978161153220349'
 import TEXT978161153220350 from '@/components/Text/978161153220350'
 import TEXT978161153220351 from '@/components/Text/978161153220351'
 import TEXT978161153220352 from '@/components/Text/978161153220352'
 import TEXT978161153220353 from '@/components/Text/978161153220353'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/TOC",
 			"name" : "Text/TOC",
 			"component" : TEXTTOC
 		},
 		{
 			"path" : "/Text/97816115322033",
 			"name" : "Text/97816115322033",
 			"component" : TEXT97816115322033
 		},
 		{
 			"path" : "/Text/97816115322034",
 			"name" : "Text/97816115322034",
 			"component" : TEXT97816115322034
 		},
 		{
 			"path" : "/Text/97816115322035",
 			"name" : "Text/97816115322035",
 			"component" : TEXT97816115322035
 		},
 		{
 			"path" : "/Text/97816115322036",
 			"name" : "Text/97816115322036",
 			"component" : TEXT97816115322036
 		},
 		{
 			"path" : "/Text/97816115322037",
 			"name" : "Text/97816115322037",
 			"component" : TEXT97816115322037
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js